import { useState, useEffect } from 'react';
import './Jobs.scss';
import { useNavigate, useParams } from 'react-router';
import cn from 'classnames';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import ReactMarkdown from 'react-markdown';
import Loader from '../../components/Loader';
import { format } from 'date-fns';

const Library = () => {
  const navigate = useNavigate();
  const id = decodeURIComponent(useParams().id);
  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const url = `https://jobs.thepioneers.ai/job/${id}/description`;
    fetch(url)
      .then(r => r.json())
      .then(res => {
        setData(res.Items);
        setIsLoading(false);
      });
  }, []);

  return (
    <div className='page'>
      <Header />
      <div className='jobPage'>
        {isLoading ? (
          <div className='loader'>{<Loader />}</div>
        ) : (
          <>
            <div className='jobBackLink' onClick={() => navigate('/jobs')}>
              <svg width='11' height='11' viewBox='0 0 11 11' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path
                  d='M5.33073 9.99833L0.664062 5.33166M0.664062 5.33166L5.33073 0.664993M0.664062 5.33166H9.9974'
                  stroke='#3abc83'
                  stroke-width='1.33'
                  stroke-linecap='round'
                  stroke-linejoin='round'
                />
              </svg>
              Back to All Jobs
            </div>
            <span className='jobPageTitle'>{data?.title}</span>
            <span className='jobPageDetails'>
              <span className='jobPageLocation'>{data.location} • </span>
              <span className='jobPageDate'>{format(new Date(data.created_time), 'MMM dd yyyy')} </span>
            </span>
            <div>
              <div className='jobPageContent'>
                <ReactMarkdown>{data?.content}</ReactMarkdown>
              </div>
              <span
                className='jobPageContactApply'
                onClick={() => window.open(`https://nextdeavor.thepioneers.ai/jobs/${data.id}`, '_blank')}
              >
                Submit Resume
              </span>
            </div>
          </>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default Library;
